define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    //var RevisionedCollection = require("collections/RevisionedCollection");
    var BaseCollection = require("collections/BaseCollection");
    var ApiResources = require("assets/data/apiResources.json");

    var HotKeysCollection = {};
    var NAME = "HotKeysCollection";
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        HotKeysCollection = BaseCollection.extend({
            name: NAME,
            model : BaseModel,
            resource: ApiResources.AccountConfig.CannedMessages,
            url: function(){
                var url = BaseCollection.prototype.url.call(this);
                //url+= "&lang="+LocaleResolver.getLocale()+ "," + LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes().join(",");//get the title in the UI language, and in the supported languages to decide
                return url += "&select=hotkey";
            },

            /*parse: function(response){
                var result = [];
                var obj = {};
                _.each(response, function(hotKey){
                    obj.prefix = hotKey.hotkey.prefix;
                    obj.suffix = hotKey.hotkey.suffix;
                    result.push(obj);
                });
                return result;
            },*/

            _getPrefixMap: function () {
                if (!this.prefixMap) {
                    var inUseHotKeys = this.toJSON();
                    //group by letters all the in use hotkeys
                    this.prefixMap = _.groupBy(inUseHotKeys, function(hotkey){return hotkey.hotkey.prefix;});
                }
                return this.prefixMap;

            },
            getAvailableLetterHotKeys: function(exisitingLetter) {

                var alphabet = "abcdefghijklmnopqrstuvwxyz";
                var allLetters = alphabet.split("");

                if (this.length < 10) //less than the 0-9 combination
                 {
                 return allLetters;
                 }

                //group by letters all the in use hotkeys
                var prefixMap = this._getPrefixMap();

                //filter only the letters that have all the numbers combined with
                var allItemsInUse = _.filter(prefixMap, function(item) {
                    return item.length > 9;
                });

                //if none found, return all the letters
                if (allItemsInUse.length === 0){
                    return allLetters;
                }

                //return array of letters only (in use)
                var allLettersInUse = _.map(allItemsInUse, function(item){return item[0].hotkey.prefix;});
                //var allLettersInUse = _.keys(allItemsInUse);

                var result = _.difference(allLetters, allLettersInUse);

                //if the selected letter in use was removed from the allowed letters - add it back
                if (!_.isNull(exisitingLetter) && result.indexOf(exisitingLetter) === -1){
                    result.push(exisitingLetter);
                }

                return result.sort();
            },

            getAvailableNumberHotKeys: function(letter, exisitingNumber) {
                var allNumbers = [0,1,2,3,4,5,6,7,8,9];

                if (_.isNull(letter)){
                    return allNumbers;
                }
                //group by letters all the in use hotkeys
                var prefixMap = this._getPrefixMap();

                //specific letter corresponding in use hotkeys combinations
                var itemsInUseForLetter = prefixMap[letter];

                //return array of numbers only (in use)
                var numbersInUseForLetter = _.map(itemsInUseForLetter, function(item){
                        return isNaN(item.hotkey.suffix) ? -1 : parseInt(item.hotkey.suffix, 10);}
                );

                var result = _.difference(allNumbers, numbersInUseForLetter);

                if (!_.isNull(exisitingNumber) && result.indexOf(exisitingNumber) === -1){
                    result.push(exisitingNumber);
                }

                return result.sort();
            }

        });
    });

    HotKeysCollection.NAME = NAME;

    return HotKeysCollection;
});
